// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4152":"4b417298","4158":"4b417298"}[chunkId] + ".chunk.css";
};